<template>
    <component
        :is="as"
        class="scroll-num"
        :class="{ 'border-animate': showAnimate }"
        :style="{ '--i': i, '--delay': delay }"
        @animationend="showAnimate = false"
    >
        <ul ref="ul" :class="{ animate: showAnimate }">
            <li v-for="(num, index) in list" :key="index">{{ num }}</li>
        </ul>

        <svg width="0" height="0">
            <filter id="blur">
                <feGaussianBlur in="SourceGraphic" :stdDeviation="`0 ${blur}`" />
            </filter>
        </svg>
    </component>
</template>

<script>
export default {
    name: 'Single',
    props: {
        as: {
            type: String,
            default: 'div'
        },
        i: {
            type: Number,
            default: 0,
            validator: (v) => v >= 0 && Number.isInteger(v)
        },
        delay: {
            type: Number,
            default: 1
        },
        blur: {
            type: Number,
            default: 2
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showAnimate: true
        };
    },
    watch: {
        i() {
            this.showAnimate = true;
        }
    }
};
</script>
